import { useEffect, useState } from 'react';
import { fetchCohorts, fetchCohortsRegion } from '../lib/api';

const fmt = n => n == null ? '·' : n.toLocaleString('en-IN');
const MONTH_LABELS = ['M0','M1','M2','M3','M4','M5'];

function colorForRate(rate, min, max) {
  if (rate == null) return 'transparent';
  const t = max === min ? 0.5 : (rate - min) / (max - min);
  // hi rate = green tint, low = red tint
  const r = Math.round(255 * (1 - t*0.5));
  const g = Math.round(200 + t*30);
  const b = Math.round(190 + t*10);
  return `rgb(${r},${g},${b})`;
}

export default function CohortsTab({ filters, entityKey }) {
  const [cohorts, setCohorts] = useState(null);
  const region = filters.region && filters.region !== 'ALL' ? filters.region : null;
  useEffect(() => {
    const p = region
      ? fetchCohortsRegion({ category: filters.category, region })
      : fetchCohorts({ category: filters.category, entityKey });
    p.then(({ data }) => setCohorts(data));
  }, [filters.category, entityKey, region]);

  if (!cohorts) return <div className="loading">Loading cohort detail…</div>;
  const rows = (cohorts[filters.channel] || []).filter(c => c.label !== '2025-04');
  const colStats = MONTH_LABELS.map((_, mi) => {
    if (mi === 0) return { min: 0, max: 100 };
    const vals = rows.map(c => c.cells[mi]?.rate).filter(v => v != null);
    return vals.length ? { min: Math.min(...vals), max: Math.max(...vals) } : { min: 0, max: 100 };
  });

  return (
    <div className="panel">
      <div className="panel-head">
        <div>
          <div className="panel-title">Cohort heatmap · {filters.channel}</div>
          <div className="panel-sub">Rows = acquisition month · columns = months since first purchase · colored within each column</div>
        </div>
      </div>
      <table className="heatmap">
        <thead>
          <tr>
            <th style={{ textAlign:'left' }}>Cohort</th>
            <th>Size</th>
            {MONTH_LABELS.map(m => <th key={m}>{m}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map(c => (
            <tr key={c.label}>
              <td className="rowhead">{c.label}</td>
              <td className="size-col">{fmt(c.size)}</td>
              {c.cells.slice(0,6).map((cell, mi) => (
                cell
                  ? <td key={mi} className="cell" style={{
                      background: mi === 0 ? 'rgba(62,142,90,0.14)' : colorForRate(cell.rate, colStats[mi].min, colStats[mi].max),
                    }}>{cell.rate.toFixed(1)}%</td>
                  : <td key={mi} className="blank">·</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
